import React from 'react';
import { offer, heroBenefits } from '../data/offer';
export function HeroSection() {
  return <section className="pt-12 pb-4 px-4 bg-white text-center" data-id="element-58" data-mp="2hvcbiccwgz1s">
      <div className="max-w-4xl mx-auto" data-id="element-59" data-mp="2hsq5wi9kktm7">
        <p className="md:text-xs text-gray-400 tracking-wider mb-4 text-[12px] font-[600]" data-id="element-60" data-mp="23vtgml93nk7f">
          "Un material práctico para preparar Catequesis sin tener que crear
          cada actividad desde cero"
        </p>

        <h1 className="text-3xl md:text-5xl font-black mb-1 leading-tight tracking-tight" data-id="element-61" data-mp="2wl0dzgwti3r3">
          <span className="px-2 text-[#14356B] bg-[#FFFFFF] text-[24px]" data-id="element-62" data-mp="30k95sg8arrk0">
            CATEQUESIS LISTAS
          </span>
        </h1>

        <div className="block max-w-[600px] mx-auto mb-3" data-id="element-63" data-mp="2mtnoux2elror">
          <img src={offer.heroImage} alt="Megapack Catequesis Listas — 120 páginas de actividades para acompañar el camino de fe" className="w-full h-auto object-contain drop-shadow-2xl rounded-xl" data-id="element-64" data-mp="2rs7cr30k5djr" />
        </div>

        <div className="text-lg md:text-xl mb-2 text-gray-700 space-y-2 max-w-3xl mx-auto font-medium" data-id="element-65" data-mp="3ka33tc1lv2wo">
          <p className="text-[14px]" data-id="element-66" data-mp="2fg1u9bf7ny4l">
            120 páginas de actividades para acompañar el camino de fe:
            Catequesis 1 + Catequesis 2 + Confirmación.
          </p>
          <p className="text-[14px]" data-id="element-67" data-mp="2p6danxg2zzsd">
            Actividades listas para trabajar la fe, conocer a Jesús, comprender
            la Biblia, prepararse para la Primera Comunión y profundizar el
            camino hacia la Confirmación.
          </p>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-3 mb-1 mt-4" data-id="element-68" data-mp="2u4erscty5p17">
          <span className="text-lg font-bold text-gray-400 line-through" data-id="element-69" data-mp="2u6r7ejc8fnb3">
            {offer.currency} {offer.oldPrice}
          </span>
          <span className="bg-[#EE6A4D] text-white text-xs font-black px-2.5 py-1 rounded-full" data-id="element-70" data-mp="334uu3iyyeq4h">
            {offer.discount}
          </span>
          <span className="text-3xl font-black text-[#14356B]" data-id="element-71" data-mp="1dqeu78ikqbh4">
            {offer.price}
          </span>
        </div>
        <p className="text-[12px] font-semibold text-gray-400 mb-5" data-id="element-72" data-mp="18tg4d25y0qoq">
          Pago único · Acceso inmediato · Descarga digital
        </p>

        <div className="bg-[#E4F1F3] rounded-2xl p-5 max-w-md mx-auto border border-[#B8DCE0]" data-id="element-73" data-mp="3drmky4ecal79">
          <p className="text-lg font-black text-gray-900 mb-3" data-id="element-74" data-mp="3ir95z00et5qm">
            👉 Beneficios del material
          </p>
          <div className="space-y-2 text-left" data-id="element-75" data-mp="3mtvt4nm4y2hh">
            {heroBenefits.map(benefit => <p key={benefit} className="text-base font-semibold text-gray-800 flex items-start" data-id="element-76" data-mp="3rsyzcbduqer1">
                <span className="text-[#157C8B] mr-2 text-lg leading-none mt-0.5" data-id="element-77" data-mp="l4bs6wle6ph">
                  ✔️
                </span>
                {benefit}
              </p>)}
          </div>
        </div>
      </div>
    </section>;
}